module.exports = __webpack_public_path__ + "static/deadpool-c1a0d13a6213e3ecf447b615828aee6a.svg";